import React from 'react';
import { useTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Grid, Icon, Typography, Theme } from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { stringToLongDateAndShortTime } from '../utils/DateUtils';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  container: {
    marginTop: theme.spacing(3),
    color: theme.color.text.textTertiary,
  },
  icon: {
    color: theme.color.text.textTertiary,
    marginRight: theme.spacing(1),
  },
  message: {
    fontWeight: 700,
  },
}));

interface DraftTimeStampProps {
  savedAt: string;
}

const DraftTimeStamp = ({ savedAt }: DraftTimeStampProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles();

  return (
    (<Grid
      xs={12}
      className={classes.container}
      direction="row"
      wrap="nowrap"
      container
      alignItems="center"
      justify="flex-start"
    >
      <Icon
        size="M"
        name={IconName.clock}
        className={classes.icon}
        color={theme.color.text.textTertiary}
      />
      <Typography className={classes.message}>
        {t('components->>DraftTimeStamp.Saved')}
        {stringToLongDateAndShortTime(savedAt)}
      </Typography>
    </Grid>)
  );
};

export default DraftTimeStamp;
